import { useEffect } from 'react'

import { Layout } from '../../components'
import { ApplicationServicesPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

import AuthPage from './AuthPage'

/**
 * @description Renders the Application Services page.
 * Inside the AuthPage component, it renders the AppBar, Drawer, and ApplicationServicesPanel components.
 * The selectedKey prop is passed to the Drawer component to highlight the 'APPLICATION_SERVICES' option.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered Application Services page.
 */
const ApplicationServicesPage = () => {

    useEffect(() => {
        document.title = 'Aplicações | LCD'
    }, [])

    return (
        <AuthPage>
            <Layout selectedKey={DRAWER_KEYS.APPLICATION_SERVICES} >
                <ApplicationServicesPanel />
            </Layout>
        </AuthPage>
    )
}

export default ApplicationServicesPage